import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditLeadStageEndpoint extends Endpoint {
    adaptValues(leadStageEdition) {
        return {
            lead_id: leadStageEdition.leadId,
            stage: leadStageEdition.stage,
        };
    }
}
